// extracted by css-extract-rspack-plugin
export default {"wrap":"wrap-eTpysT","img":"img-TFMFtm","title":"title-z0pbtC"};